import { ACTION_AUTHEN_REQUEST_OTP, ACTION_AUTHEN_REQUEST_OTP_ERROR, ACTION_AUTHEN_REQUEST_OTP_SUCCESS } from "."
import * as api from "../../../api"

export const requestOTPRequest = (userid, appInfo, url) => ({
    type: ACTION_AUTHEN_REQUEST_OTP,
    payload: {
        userid,
        appInfo,
        url
    }
})

export const requestOTPSuccess = data => ({
    type: ACTION_AUTHEN_REQUEST_OTP_SUCCESS,
    payload: {
        data
    }
})


export const requestOTPError = msg => ({
    type: ACTION_AUTHEN_REQUEST_OTP_ERROR,
    payload: {
        msg
    }
})

export const requestOTP = (userid, appInfo, url) => {
    return dispatch => {
        dispatch(requestOTPRequest(userid, appInfo, url))
        api.requestOTP(userid, appInfo, url)
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(requestOTPError("error"));
                    return
                }
                delete data["result"]
                dispatch(requestOTPSuccess(data));
            }).catch((err) => {

                console.log(err)

                dispatch(requestOTPError("system error"))
            });
    }
}